@if (configuration != null) {
  <div class="part-number-change-footer"
    data-cy="part-number-change-footer">
    @if (configuration?.thirdButton != null) {
      <div class="part-number-change-footer-left-section">
        <button (click)="footerClick($safeNavigationMigration(configuration?.thirdButton?.action))"
          [disabled]="$safeNavigationMigration(configuration?.thirdButton?.disable)"
          class="{{configuration?.thirdButton?.class}}"
          data-cy="part-number-change-footer-cancel-button"
          type="button">
          <span class="text">{{configuration?.thirdButton?.label}}</span>
        </button>
      </div>
    }
    <div class="part-number-change-footer-right-section">
      @if (configuration.secondaryButton != null) {
        <button (click)="footerClick($safeNavigationMigration(configuration?.secondaryButton?.action))"
          [disabled]="$safeNavigationMigration(configuration?.secondaryButton?.disable)"
          class="{{configuration?.secondaryButton?.class}}"
          data-cy="part-number-change-footer-secondary-button"
          type="button">
          <span class="text">{{configuration?.secondaryButton?.label}}</span>
        </button>
      }
      @if (configuration.primaryButton != null) {
        <button (click)="footerClick($safeNavigationMigration(configuration?.primaryButton?.action))"
          [disabled]="$safeNavigationMigration(configuration?.primaryButton?.disable)"
          class="{{configuration?.primaryButton?.class}} pnc-footer-primary-button"
          data-cy="part-number-change-footer-primary-button"
        type="button">{{configuration?.primaryButton?.label}}</button>
      }
    </div>
  </div>
}
